// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * LabelFlow Design System — 2026
 * Dark-first professional workspace for an AI labeling platform.
 * Every color in the app must come from these tokens; pages never hardcode hex.
 *
 * Theme switching: \`dark\` / \`light\` class on <html> (see Header toggle).
 * Default is dark — set in src/index.js before first paint.
 */

:root {
  /* === Shape === */
  --radius-sm: 0.375rem;
  --radius: 0.625rem;
  --radius-lg: 0.875rem;
  --radius-xl: 1.25rem;
  --radius-full: 9999px;

  /* === Motion === */
  --transition-fast: 120ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition: 180ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);

  /* === Typography === */
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;

  /* === Brand === */
  --brand-300: #6ee7b7;
  --brand-400: #34d399;
  --brand-500: #10b981;
  --brand-600: #059669;
  --brand-700: #047857;

  /* ==========================================================
     LIGHT THEME (default at :root so nothing ever lacks a value)
     ========================================================== */
  --background: #f7f8fa;
  --foreground: #101418;

  --card: #ffffff;
  --card-foreground: #101418;
  --card-hover: #fbfcfd;

  --popover: #ffffff;
  --popover-foreground: #101418;
  --overlay: rgba(15, 18, 22, 0.55);

  --primary: var(--brand-600);
  --primary-hover: var(--brand-700);
  --primary-foreground: #ffffff;
  --primary-soft: rgba(5, 150, 105, 0.10);

  --secondary: #eef1f4;
  --secondary-hover: #e4e8ed;
  --secondary-foreground: #1c2228;

  --muted: #f0f2f5;
  --muted-foreground: #5b6572;

  --accent: #e8faf2;
  --accent-foreground: var(--brand-700);

  --destructive: #dc2626;
  --destructive-hover: #b91c1c;
  --destructive-foreground: #ffffff;
  --destructive-soft: rgba(220, 38, 38, 0.10);

  --success: var(--brand-600);
  --warning: #d97706;
  --warning-soft: rgba(217, 119, 6, 0.12);
  --info: #0284c7;
  --info-soft: rgba(2, 132, 199, 0.10);

  --border: #e3e7ec;
  --border-strong: #cdd4dc;
  --input: #dde2e8;
  --ring: rgba(16, 185, 129, 0.35);

  --chart-1: #059669;
  --chart-2: #0ea5e9;
  --chart-3: #8b5cf6;
  --chart-4: #f59e0b;
  --chart-5: #ec4899;

  --header: rgba(255, 255, 255, 0.85);
  --header-foreground: #101418;
  --header-border: #e3e7ec;

  --sidebar: #ffffff;
  --sidebar-foreground: #101418;
  --sidebar-primary: var(--brand-600);
  --sidebar-primary-foreground: #ffffff;
  --sidebar-accent: #e8faf2;
  --sidebar-accent-foreground: var(--brand-700);
  --sidebar-border: #e3e7ec;
  --sidebar-ring: var(--brand-600);

  --page-bg: #f7f8fa;
  --page-bg-subtle: #eef1f4;

  --scrollbar-thumb: #c8cfd7;
  --scrollbar-thumb-hover: #aab3bd;

  --shadow-sm: 0 1px 2px 0 rgb(16 20 24 / 0.05);
  --shadow: 0 1px 3px 0 rgb(16 20 24 / 0.08), 0 1px 2px -1px rgb(16 20 24 / 0.08);
  --shadow-md: 0 4px 10px -2px rgb(16 20 24 / 0.10), 0 2px 4px -2px rgb(16 20 24 / 0.06);
  --shadow-lg: 0 12px 28px -6px rgb(16 20 24 / 0.16), 0 4px 10px -4px rgb(16 20 24 / 0.08);
  --shadow-glow: 0 0 0 1px rgba(16, 185, 129, 0.25), 0 4px 18px -2px rgba(16, 185, 129, 0.25);
}

/* ==========================================================
   DARK THEME — the default workspace look
   ========================================================== */
html.dark,
.dark {
  --background: #0b0c0e;
  --foreground: #ecedee;

  --card: #131518;
  --card-foreground: #ecedee;
  --card-hover: #17191d;

  --popover: #17191d;
  --popover-foreground: #ecedee;
  --overlay: rgba(0, 0, 0, 0.65);

  --primary: var(--brand-500);
  --primary-hover: var(--brand-400);
  --primary-foreground: #06251b;
  --primary-soft: rgba(16, 185, 129, 0.14);

  --secondary: #1d2024;
  --secondary-hover: #24282d;
  --secondary-foreground: #d7dadd;

  --muted: #1a1d21;
  --muted-foreground: #9aa3ad;

  --accent: rgba(16, 185, 129, 0.12);
  --accent-foreground: var(--brand-300);

  --destructive: #f87171;
  --destructive-hover: #ef4444;
  --destructive-foreground: #2a0808;
  --destructive-soft: rgba(248, 113, 113, 0.12);

  --success: var(--brand-400);
  --warning: #fbbf24;
  --warning-soft: rgba(251, 191, 36, 0.12);
  --info: #38bdf8;
  --info-soft: rgba(56, 189, 248, 0.12);

  --border: rgba(255, 255, 255, 0.08);
  --border-strong: rgba(255, 255, 255, 0.16);
  --input: rgba(255, 255, 255, 0.12);
  --ring: rgba(52, 211, 153, 0.40);

  --chart-1: #34d399;
  --chart-2: #38bdf8;
  --chart-3: #a78bfa;
  --chart-4: #fbbf24;
  --chart-5: #f472b6;

  --header: rgba(11, 12, 14, 0.80);
  --header-foreground: #ecedee;
  --header-border: rgba(255, 255, 255, 0.08);

  --sidebar: #0f1114;
  --sidebar-foreground: #ecedee;
  --sidebar-primary: var(--brand-500);
  --sidebar-primary-foreground: #06251b;
  --sidebar-accent: rgba(16, 185, 129, 0.12);
  --sidebar-accent-foreground: var(--brand-300);
  --sidebar-border: rgba(255, 255, 255, 0.08);
  --sidebar-ring: var(--brand-500);

  --page-bg: #0b0c0e;
  --page-bg-subtle: #111316;

  --scrollbar-thumb: #2c3137;
  --scrollbar-thumb-hover: #3a4048;

  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.4);
  --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.5), 0 1px 2px -1px rgb(0 0 0 / 0.4);
  --shadow-md: 0 4px 12px -2px rgb(0 0 0 / 0.55), 0 2px 4px -2px rgb(0 0 0 / 0.4);
  --shadow-lg: 0 16px 40px -8px rgb(0 0 0 / 0.65), 0 4px 12px -4px rgb(0 0 0 / 0.5);
  --shadow-glow: 0 0 0 1px rgba(52, 211, 153, 0.30), 0 4px 22px -2px rgba(16, 185, 129, 0.30);

  color-scheme: dark;
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAIF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;;EAErB,mBAAmB;EACnB,qDAAqD;EACrD,gDAAgD;EAChD,qDAAqD;;EAErD,uBAAuB;EACvB,uFAAuF;EACvF,uFAAuF;;EAEvF,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB;;iEAE+D;EAC/D,qBAAqB;EACrB,qBAAqB;;EAErB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;;EAErB,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;;EAEjC,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;;EAEvC,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;;EAE/B,gBAAgB;EAChB,2BAA2B;;EAE3B,iBAAiB;EACjB,qCAAqC;;EAErC,sBAAsB;EACtB,4BAA4B;EAC5B,iCAAiC;EACjC,2CAA2C;;EAE3C,2BAA2B;EAC3B,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,oCAAoC;;EAEpC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;;EAEhC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,mCAAmC;EACnC,4BAA4B;EAC5B,wBAAwB;;EAExB,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;EACzB,gCAAgC;;EAEhC,kBAAkB;EAClB,yBAAyB;;EAEzB,0BAA0B;EAC1B,gCAAgC;;EAEhC,6CAA6C;EAC7C,+EAA+E;EAC/E,sFAAsF;EACtF,wFAAwF;EACxF,2FAA2F;AAC7F;;AAEA;;+DAE+D;AAC/D;;EAEE,qBAAqB;EACrB,qBAAqB;;EAErB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;;EAErB,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;;EAE9B,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,wCAAwC;;EAExC,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;;EAE/B,gBAAgB;EAChB,2BAA2B;;EAE3B,kCAAkC;EAClC,qCAAqC;;EAErC,sBAAsB;EACtB,4BAA4B;EAC5B,iCAAiC;EACjC,6CAA6C;;EAE7C,2BAA2B;EAC3B,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,qCAAqC;;EAErC,mCAAmC;EACnC,0CAA0C;EAC1C,kCAAkC;EAClC,gCAAgC;;EAEhC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,gCAAgC;EAChC,4BAA4B;EAC5B,0CAA0C;;EAE1C,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,0CAA0C;EAC1C,6CAA6C;EAC7C,2CAA2C;EAC3C,gCAAgC;;EAEhC,kBAAkB;EAClB,yBAAyB;;EAEzB,0BAA0B;EAC1B,gCAAgC;;EAEhC,yCAAyC;EACzC,uEAAuE;EACvE,+EAA+E;EAC/E,iFAAiF;EACjF,2FAA2F;;EAE3F,kBAAkB;AACpB","sourcesContent":["/**\n * LabelFlow Design System — 2026\n * Dark-first professional workspace for an AI labeling platform.\n * Every color in the app must come from these tokens; pages never hardcode hex.\n *\n * Theme switching: `dark` / `light` class on <html> (see Header toggle).\n * Default is dark — set in src/index.js before first paint.\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600&display=swap');\n\n:root {\n  /* === Shape === */\n  --radius-sm: 0.375rem;\n  --radius: 0.625rem;\n  --radius-lg: 0.875rem;\n  --radius-xl: 1.25rem;\n  --radius-full: 9999px;\n\n  /* === Motion === */\n  --transition-fast: 120ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition: 180ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* === Typography === */\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n\n  /* === Brand === */\n  --brand-300: #6ee7b7;\n  --brand-400: #34d399;\n  --brand-500: #10b981;\n  --brand-600: #059669;\n  --brand-700: #047857;\n\n  /* ==========================================================\n     LIGHT THEME (default at :root so nothing ever lacks a value)\n     ========================================================== */\n  --background: #f7f8fa;\n  --foreground: #101418;\n\n  --card: #ffffff;\n  --card-foreground: #101418;\n  --card-hover: #fbfcfd;\n\n  --popover: #ffffff;\n  --popover-foreground: #101418;\n  --overlay: rgba(15, 18, 22, 0.55);\n\n  --primary: var(--brand-600);\n  --primary-hover: var(--brand-700);\n  --primary-foreground: #ffffff;\n  --primary-soft: rgba(5, 150, 105, 0.10);\n\n  --secondary: #eef1f4;\n  --secondary-hover: #e4e8ed;\n  --secondary-foreground: #1c2228;\n\n  --muted: #f0f2f5;\n  --muted-foreground: #5b6572;\n\n  --accent: #e8faf2;\n  --accent-foreground: var(--brand-700);\n\n  --destructive: #dc2626;\n  --destructive-hover: #b91c1c;\n  --destructive-foreground: #ffffff;\n  --destructive-soft: rgba(220, 38, 38, 0.10);\n\n  --success: var(--brand-600);\n  --warning: #d97706;\n  --warning-soft: rgba(217, 119, 6, 0.12);\n  --info: #0284c7;\n  --info-soft: rgba(2, 132, 199, 0.10);\n\n  --border: #e3e7ec;\n  --border-strong: #cdd4dc;\n  --input: #dde2e8;\n  --ring: rgba(16, 185, 129, 0.35);\n\n  --chart-1: #059669;\n  --chart-2: #0ea5e9;\n  --chart-3: #8b5cf6;\n  --chart-4: #f59e0b;\n  --chart-5: #ec4899;\n\n  --header: rgba(255, 255, 255, 0.85);\n  --header-foreground: #101418;\n  --header-border: #e3e7ec;\n\n  --sidebar: #ffffff;\n  --sidebar-foreground: #101418;\n  --sidebar-primary: var(--brand-600);\n  --sidebar-primary-foreground: #ffffff;\n  --sidebar-accent: #e8faf2;\n  --sidebar-accent-foreground: var(--brand-700);\n  --sidebar-border: #e3e7ec;\n  --sidebar-ring: var(--brand-600);\n\n  --page-bg: #f7f8fa;\n  --page-bg-subtle: #eef1f4;\n\n  --scrollbar-thumb: #c8cfd7;\n  --scrollbar-thumb-hover: #aab3bd;\n\n  --shadow-sm: 0 1px 2px 0 rgb(16 20 24 / 0.05);\n  --shadow: 0 1px 3px 0 rgb(16 20 24 / 0.08), 0 1px 2px -1px rgb(16 20 24 / 0.08);\n  --shadow-md: 0 4px 10px -2px rgb(16 20 24 / 0.10), 0 2px 4px -2px rgb(16 20 24 / 0.06);\n  --shadow-lg: 0 12px 28px -6px rgb(16 20 24 / 0.16), 0 4px 10px -4px rgb(16 20 24 / 0.08);\n  --shadow-glow: 0 0 0 1px rgba(16, 185, 129, 0.25), 0 4px 18px -2px rgba(16, 185, 129, 0.25);\n}\n\n/* ==========================================================\n   DARK THEME — the default workspace look\n   ========================================================== */\nhtml.dark,\n.dark {\n  --background: #0b0c0e;\n  --foreground: #ecedee;\n\n  --card: #131518;\n  --card-foreground: #ecedee;\n  --card-hover: #17191d;\n\n  --popover: #17191d;\n  --popover-foreground: #ecedee;\n  --overlay: rgba(0, 0, 0, 0.65);\n\n  --primary: var(--brand-500);\n  --primary-hover: var(--brand-400);\n  --primary-foreground: #06251b;\n  --primary-soft: rgba(16, 185, 129, 0.14);\n\n  --secondary: #1d2024;\n  --secondary-hover: #24282d;\n  --secondary-foreground: #d7dadd;\n\n  --muted: #1a1d21;\n  --muted-foreground: #9aa3ad;\n\n  --accent: rgba(16, 185, 129, 0.12);\n  --accent-foreground: var(--brand-300);\n\n  --destructive: #f87171;\n  --destructive-hover: #ef4444;\n  --destructive-foreground: #2a0808;\n  --destructive-soft: rgba(248, 113, 113, 0.12);\n\n  --success: var(--brand-400);\n  --warning: #fbbf24;\n  --warning-soft: rgba(251, 191, 36, 0.12);\n  --info: #38bdf8;\n  --info-soft: rgba(56, 189, 248, 0.12);\n\n  --border: rgba(255, 255, 255, 0.08);\n  --border-strong: rgba(255, 255, 255, 0.16);\n  --input: rgba(255, 255, 255, 0.12);\n  --ring: rgba(52, 211, 153, 0.40);\n\n  --chart-1: #34d399;\n  --chart-2: #38bdf8;\n  --chart-3: #a78bfa;\n  --chart-4: #fbbf24;\n  --chart-5: #f472b6;\n\n  --header: rgba(11, 12, 14, 0.80);\n  --header-foreground: #ecedee;\n  --header-border: rgba(255, 255, 255, 0.08);\n\n  --sidebar: #0f1114;\n  --sidebar-foreground: #ecedee;\n  --sidebar-primary: var(--brand-500);\n  --sidebar-primary-foreground: #06251b;\n  --sidebar-accent: rgba(16, 185, 129, 0.12);\n  --sidebar-accent-foreground: var(--brand-300);\n  --sidebar-border: rgba(255, 255, 255, 0.08);\n  --sidebar-ring: var(--brand-500);\n\n  --page-bg: #0b0c0e;\n  --page-bg-subtle: #111316;\n\n  --scrollbar-thumb: #2c3137;\n  --scrollbar-thumb-hover: #3a4048;\n\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.4);\n  --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.5), 0 1px 2px -1px rgb(0 0 0 / 0.4);\n  --shadow-md: 0 4px 12px -2px rgb(0 0 0 / 0.55), 0 2px 4px -2px rgb(0 0 0 / 0.4);\n  --shadow-lg: 0 16px 40px -8px rgb(0 0 0 / 0.65), 0 4px 12px -4px rgb(0 0 0 / 0.5);\n  --shadow-glow: 0 0 0 1px rgba(52, 211, 153, 0.30), 0 4px 22px -2px rgba(16, 185, 129, 0.30);\n\n  color-scheme: dark;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
